import React from 'react';
import { Route } from 'react-router-dom';
import { DishModal } from '../DishModal';

export const Modals = () => (
  <React.Fragment>
    <Route path={'/lists/:dishListSlug/dishes/:dishSlug'}>
      <DishModal />
    </Route>
    <Route path={'/places/:placeSlug/categories/:categorySlug/dishes/:dishSlug'}>
      <DishModal />
    </Route>
    <Route path={'/places/:placeSlug/dishes/:dishSlug'}>
      <DishModal />
    </Route>
  </React.Fragment>
);
